module.exports = __webpack_public_path__ + "img/SearchBySplint-02.12aea0ab.svg";